// Backend error codes for QR editor saves. Kept in a dependency-free module so that
// utilities can import them without pulling in qrEditorHelper (avoids import cycles).
export const REFERENCE_EXITS = "reference_already_exists";
export const QR_REFERENCE_NOT_VALID = "invalid_qr_code_reference";
